<h1 mat-dialog-title>Visible Columns</h1>
<div mat-dialog-content style="overflow:hidden;">
  <div *ngFor="let col of data">
    <mat-checkbox [checked]="col.visible" [disabled]="!col.canBeRemoved" (change)="col.visible = !col.visible">{{col.userReadableName}}</mat-checkbox>
  </div>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-button (click)="selectAll()">
    <span *ngIf="canSelectAll()">Select All</span>
    <span *ngIf="!canSelectAll()">Deselect All</span>
  </button>
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Apply</button>
</div>
